import { useState } from "react"
import { FieldValues, UseFormSetValue } from "react-hook-form"

import { setAddressFields } from "../../../../components/submitApplication/single/recognisedInputs/addressForm"
import { SUPPORT_REFER } from "../../../../errors/errorMessages"
import { snackbar } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import { getSingleAddressMapper } from "../../mappers/singleApplication/getSingleAddressMapper"
import { IPlaceID } from "../../types/singleApplication/getPlacesTypes"
import { PLACES_ID_API } from "../../urls/hybrid"

/**
 * Custom hook for retrieving place ID and related address information.
 * @param setValue - Function to set form field values.
 * @returns An object containing the getAddressWiD function and isLoading flag.
 */
const usePlaceID = (setValue: UseFormSetValue<FieldValues>): IPlaceID => {
    const [isLoading, setIsLoading] = useState(false)
    const getAddressWiD = async (placeId: string): Promise<void> => {
        try {
            setIsLoading(true)
            const res = await getClientProtected(PLACES_ID_API(placeId))
            const resProcessed = getSingleAddressMapper.map(res)
            setAddressFields(
                setValue,
                resProcessed.Label,
                resProcessed.PostalCode
            )
        } catch (err) {
            snackbar(
                `Unable to search for address. Please try again. ${SUPPORT_REFER}`,
                "warning"
            )
        } finally {
            setIsLoading(false)
        }
    }
    return {
        getAddressWiD,
        isLoading,
    }
}
export default usePlaceID
